module.exports = __webpack_public_path__ + "img/left-arrow.4f003b47.svg";